module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vcirc10-e300e6c2d61ebcb71d8657ba4cb59d96.jpg";